export const GET_LIST = 'ADVERTISERS/GET_LIST'
export const SET_STATUS = 'ADVERTISERS/SET_STATUS'
export const SET_FILTERS = 'ADVERTISERS/SET_FILTERS'
export const DROP_LIST = 'ADVERTISERS/DROP_LIST'
export const REMOVE_FROM_LIST = 'ADVERTISERS/REMOVE_FROM_LIST'
export const SET_LOADING = 'ADVERTISERS/SET_LOADING'
export const SET_DATA = 'ADVERTISERS/SET_DATA'
export const SET_ITEM_DATA = 'ADVERTISERS/SET_ITEM_DATA'
